// removed by extract-text-webpack-plugin
module.exports = {"table-information":"TableInformation__table-information___3r5Md"};